"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHLocalStorageWrapper = void 0;
/**
 * Wraps access to local storage, catching any exceptions.
 */
class KHLocalStorageWrapper {
    constructor(key) {
        this.key = key;
    }
    load() {
        let jsonStr = "";
        this.storageAccessDenied = false;
        try {
            jsonStr = localStorage.getItem(this.key);
        }
        catch (e) {
            console.warn("Unable to read from local storage. Persistent storage will not work.", e);
            this.storageAccessDenied = true;
        }
        try {
            const json = JSON.parse(jsonStr);
            return json !== null && json !== void 0 ? json : {};
        }
        catch (e) {
            console.warn("Error parsing options: " + jsonStr);
            return {};
        }
    }
    wasStorageAccessDenied() {
        return this.storageAccessDenied;
    }
    /**
     * Attempts to save a JSON object to local storage.
     * @param json JSON object to save
     * @returns Whether or not the state saved successfully.
     */
    save(json) {
        try {
            localStorage.setItem(this.key, JSON.stringify(json));
            return true;
        }
        catch (e) {
            console.warn("Failed to save content.");
            return false;
        }
    }
}
exports.KHLocalStorageWrapper = KHLocalStorageWrapper;
